import React from "react";
import _ from "lodash";
import moment from "moment";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import "./index.css";
import ChatbotMakerForm from "./ChatbotMakerForm";
import EditChatbotModal from "./EditChatbotModal";

const Journeys = [
  {
    img: require("../../assets/media/chatbotmakers/ux.png"),
    title: "Proactively engage",
    text: "visitors 24/7 to shorten the time it takes to convert them.",
  },
  {
    img: require("../../assets/media/chatbotmakers/impact.png"),
    title: "Bespoke your bot",
    text: "UX, statements, personalisation, questions and answers.",
  },
  {
    img: require("../../assets/media/chatbotmakers/data-sharing.png"),
    title: "Collect and verify",
    text: "age, mobile, KYC, addresses and any binary information you wish.",
  },
  {
    img: require("../../assets/media/chatbotmakers/graph.png"),
    title: "Grow artificially ",
    text: "without any human interaction, as you propel referrals and deep insight.",
  },
  {
    img: require("../../assets/media/chatbotmakers/ecology-and-environment.png"),
    title: "Publish smoothly",
    text: "bot statements questions and answers to build smooth chats.",
  },
  {
    img: require("../../assets/media/chatbotmakers/analysis.png"),
    title: "Analyse results",
    text: "of your new auto service routings, editing your bots to reflect insights.",
  },
];
class ChatbotMaker extends React.PureComponent {
  chatbotForm = null;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      brand: null,
      brandData: {},
      viewMode: 0,
      selectedChatbotId: null,
      publishBtnDisable: true,
      chatbot: null,
    };
  }

  async componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ brand, username, role, loading: true });

      Firebase.getBrandDataByID(brand, (brandData) => {
        this.setState({ brandData, loading: false });
      });
    }
  }

  handleInputChange = (event) => {
    const { chatbot } = this.state;
    const { name, value } = event.target;

    const newChatbot = _.cloneDeep(chatbot);
    newChatbot[name] = value;
    this.setState({ chatbot: newChatbot });
  };

  handleLayerChange = (index, key, value) => {
    const { chatbot } = this.state;
    const newChatbot = _.cloneDeep(chatbot);
    newChatbot["communicationLayers"][index][key] = value;
    this.setState({ chatbot: newChatbot });
  };

  addNewCommunicationLayer = () => {
    const { chatbot } = this.state;
    const newChatbot = _.cloneDeep(chatbot);
    newChatbot["communicationLayers"].push({ type: "", statement: "" });
    this.setState({ chatbot: newChatbot });
  };

  publishChatbot = (chatbot) => {
    const { brand } = this.state;
    Firebase.addBrandChatbot(brand, {
      ...chatbot,
      created_at: new Date(),
      users: 0,
    });
  };

  updateChatbot = (chatbot) => {
    const { brand } = this.state;
    Firebase.updateChatbotById(brand, this.state.selectedChatbotId, {
      ...chatbot,
      updated_at: new Date(),
    });
  };

  deleteChatbot = (chatbot) => {
    const { brand } = this.state;
    Firebase.deleteChatbotById(brand, this.state.selectedChatbotId);
  };

  copyUrl = (chatbot_name) => {
    const { brandData } = this.state;
    let value = `https://ecosystem.club/${brandData.name.replace(
      /\s/g,
      ""
    )}?chatbot=${chatbot_name}`;
    navigator.clipboard.writeText(value);
  };
  renderNewChatbot = () => {
    const { chatbot } = this.state;
    return (
      <React.Fragment>
        <ChatbotMakerForm
          ref={(ref) => (this.chatbotForm = ref)}
          publishChatbot={this.publishChatbot}
          onUpdateStatus={(chatbot) => {
            this.setState({
              chatbot,
              publishBtnDisable:
                !chatbot.name ||
                !chatbot.icon ||
                !chatbot.welcomeText ||
                chatbot.toc === undefined ||
                (chatbot.toc && !chatbot.tocText),
            });
          }}
        />

        <div className="chatbot-add-new-layer-options mt-3">
          {chatbot &&
            chatbot.name &&
            chatbot.icon &&
            chatbot.welcomeText &&
            chatbot.toc !== undefined && (
              <button
                className={`btn warning-button bg-white`}
                type="button"
                onClick={() =>
                  this.chatbotForm
                    ? this.chatbotForm.addNewCommunicationLayer()
                    : null
                }
              >
                Add new communication layer
              </button>
            )}
        </div>
        <div className="chatbot-publish-options mt-3">
          {!this.state.publishBtnDisable && (
            <button
              className={`btn warning-button action-button`}
              type="button"
              onClick={() =>
                this.chatbotForm ? this.chatbotForm.publishChatbot() : null
              }
              style={{ marginLeft: 20 }}
            >
              Publish your chatbot
            </button>
          )}
        </div>
      </React.Fragment>
    );
  };

  renderChatbots = () => {
    const { brandData } = this.state;
    const chatbotIds = Object.keys(brandData.chatbots || {});

    return (
      <React.Fragment>
        {chatbotIds.map((id) => {
          const chatbot = brandData.chatbots[id];
          return (
            <div className="chatbot-item" key={chatbot.name}>
              <div className="chatbot-item-icon">
                <img width={60} height={60} src={chatbot.icon} alt="icon"></img>
              </div>
              <div style={{ flex: 1 }}>
                <h4>Chatbot Name - {chatbot.name}</h4>
                <p>
                  Created - {moment(chatbot.created_at).format("DD.MM.YYYY")}
                </p>
                <p>Number of users - {chatbot.users}</p>
              </div>
              <div className="btn-container">
                <button
                  className="btn btn-primary action-button"
                  onClick={() => this.copyUrl(chatbot.name)}
                >
                  Copy to clipboard
                </button>
                <button
                  className="btn btn-warning warning-button"
                  data-toggle="modal"
                  data-target="#edit_chatbot_form_modal"
                  onClick={() => this.setState({ selectedChatbotId: id })}
                >
                  Edit
                </button>
              </div>
            </div>
          );
        })}
      </React.Fragment>
    );
  };

  render() {
    const { brand, loading, brandData, viewMode, selectedChatbotId } =
      this.state;

    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={brandData.logo}
          brand={brand}
          brandName={brandData.name}
          is_property_brand={brandData.is_property_brand}
        />

        <main id="main-container">
          <div className="home-content">
            {loading && (
              <div className="loading">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
            {!loading && (
              <React.Fragment>
                <div className="chatbot-maker-content pb-5">
                  <div className="chatbot-maker-options">
                    <button
                      className={`btn btn-secondary`}
                      style={{
                        color:
                          viewMode === 0
                            ? brandData.white
                              ? "white"
                              : "black"
                            : "black",
                        backgroundColor:
                          viewMode === 0 ? brandData.hex : "white",
                      }}
                      type="button"
                      onClick={() => {
                        this.setState({ viewMode: 0 });
                      }}
                    >
                      New Chatbot
                    </button>
                    <button
                      className={`btn`}
                      style={{
                        color:
                          viewMode === 1
                            ? brandData.white
                              ? "white"
                              : "black"
                            : "black",
                        backgroundColor:
                          viewMode === 1 ? brandData.hex : "white",
                      }}
                      type="button"
                      onClick={() => {
                        this.setState({ viewMode: 1 });
                      }}
                    >
                      Active Chatbots
                    </button>
                  </div>
                  {viewMode === 0
                    ? this.renderNewChatbot()
                    : this.renderChatbots()}
                </div>
                <div className="journey-container">
                  {Journeys.map((obj, i) => (
                    <div className="journey-item" key={i}>
                      <div className="journey-item-avatar">
                        <img src={obj.img} alt="img" />
                      </div>
                      <b>{obj.title}</b>
                      <p>{obj.text}</p>
                    </div>
                  ))}
                </div>
              </React.Fragment>
            )}
          </div>
        </main>
        <EditChatbotModal
          chatbot={
            selectedChatbotId
              ? (brandData.chatbots || {})[selectedChatbotId]
              : null
          }
          updateChatbot={this.updateChatbot}
          deleteChatbot={this.deleteChatbot}
        />
      </div>
    );
  }
}
export default ChatbotMaker;



// WEBPACK FOOTER //
// ./src/screens/ChatbotMaker/index.js